import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '~/components/ui/Accordion';

type MobileAccordionItemProps = {
  label: string;
  children: React.ReactNode;
};

const MobileAccordionItem = ({ label, children }: MobileAccordionItemProps) => {
  const accordionClasses =
    'border-t border-stone-100 px-2 pt-2 first:border-t-0';
  const triggerClasses =
    'font-display flex items-center px-2 py-3 text-sm font-bold text-stone-700 no-underline transition-colors hover:text-blue-600';

  return (
    <Accordion type="multiple" className={accordionClasses}>
      <AccordionItem value={label}>
        <AccordionTrigger className={triggerClasses}>
          <span className="mr-auto">{label}</span>
        </AccordionTrigger>
        <AccordionContent>{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default MobileAccordionItem;
